// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EKrzO","question":"styles_question__3gY_r","inputVisibleButton":"styles_inputVisibleButton__rfyrk","note":"styles_note__3iBK9"};